import { SimpleQueryResponse } from './../../../shared/dtos/simpleQueryResponse';
import { ModalAddUserComponent } from './../modal-add-user/modal-add-user.component';
import { SimpleQueryUser } from './../../../shared/dtos/simpleQueryUser';
import { AfterViewInit, Component, ViewChild, EventEmitter, Output, OnInit } from '@angular/core';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent} from '@angular/material/legacy-paginator';
import { UtilisateurModel } from 'src/app/shared/models/utilisateur/utilisateur.model';
import { Router } from '@angular/router';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { UserService } from 'src/app/shared/services/user.service';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit {
  users: UtilisateurModel[] = [];
  displayedColumns: string[] = ['nom', 'prenom', 'tel', 'societe', 'email'];
  dataSource = new MatTableDataSource<UtilisateurModel>();
  length: number;
  pageSize = 25;
  objet: SimpleQueryUser = new SimpleQueryUser();
  pageEvent: PageEvent;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor( public router: Router, public dialog: MatDialog, private userService: UserService) {}
  ngOnInit(): void {
    this.objet.query = '';
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.objet.order = 'nom';
    this.dataSource.paginator = this.paginator;
    this.load_user();
  }

  load_user(): void {
    this.userService.getFromSimpleQuery(this.objet).subscribe((query: SimpleQueryResponse<UtilisateurModel>) => {
      if (query.objets != null) {
        this.users = this.orderUsers(query.objets);
      } else {
        this.users = [];
      }
      this.length = query.count;
      this.dataSource.data = this.users;
    });
  }

  orderUsers(users: UtilisateurModel[]): UtilisateurModel[] {
    users = users.sort((a, b) => {
      if (a.nom) {
        return a.nom.localeCompare(b.nom);
      } else {
        return -1;
      }
    });
    return users;
  }

  create_user(): void {
    const dialogRef = this.dialog.open(ModalAddUserComponent, {
      width: '60%',
      data: {email: null}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
         this.load_user();
       }
    });
  }


  openEvent(user: UtilisateurModel): void {
    this.router.navigate(['/user-record/' + user.id]);
  }

  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    if (this.objet.query.trim() !== ''){
      this.objet.pageNumber = 0;
      this.objet.pageSize = this.pageSize;
      this.paginator.pageIndex = 0;
      this.loadPage();
    }
  }

  loadPage(): void {
    this.userService.getFromSimpleQuery(this.objet).subscribe((query: SimpleQueryResponse<UtilisateurModel>) => {
      if (query.objets != null) {
        this.users = query.objets;
      } else {
        this.users = [];
      }
      this.length = query.count;
      this.dataSource = new MatTableDataSource<UtilisateurModel>(this.users);
      this.paginator.length = this.length;
    });
  }
}
